import React, { useState } from 'react'
import styled from '@emotion/styled'
import { Button , Modal } from 'antd'
import { EditOutlined, StopOutlined, CreditCardOutlined } from '@ant-design/icons'
import { colors } from 'style/theme'

const StyledTransactionsTop = styled.div({
  display: 'flex',
  alignItems: 'center',
  padding: '0.625rem 1.25rem',
  "justify-content": "flex-end"
})

const CreateButton = styled(Button)({
  margin: '4px',
})

const StyledModal = styled(Modal)`
  .ant-modal-footer button {
    margin: .5rem;
  }
`

const Text = styled.div`
  text-align: center;
  display: grid;
  grid-gap: 0.5rem;
`

const Header = styled.div`
  font-size: 1rem;
`
const Amount = styled.span`
  font-weight: 800;
  color: ${colors.brandDark};
`

const Footer = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  color: ${colors.brandButton};
`

const TransactionsListTop = ({subscriptionIsActive, cancelFee, setEditModalVisible, cancelSubscription, setRenewModalVisible}) => {
	const [cancelModalVisible, setCancelModalVisible] = useState(false);

  return (
    subscriptionIsActive ? 
    <div>
        <StyledTransactionsTop>
        <CreateButton type="primary" onClick={() => setEditModalVisible(true)} >
          <EditOutlined /> EDIT CREDIT CARD
        </CreateButton>
          <CreateButton type="primary" onClick={() => setCancelModalVisible(true)}>
            <StopOutlined /> CANCEL SUBSCRIPTION
          </CreateButton>
      </StyledTransactionsTop>

      <StyledModal
        title={"Cancel Subscription"}
				width={740}
        visible={cancelModalVisible}
				onCancel={() => setCancelModalVisible(false)}
				footer={[
          <Button onClick={() => setCancelModalVisible(false)}>
            Keep
          </Button>,
          <Button type="primary" onClick={() => cancelSubscription()}>
            Charge and Cancel Subscription
          </Button>,
        ]}
			>
        <Text>
          <Header>Your credit card will be charged <Amount>{cancelFee}</Amount> USD now based upon the usage during this billing cycle.</Header>
          <Footer>You can always enable subscription by clicking ‘Enable Subscription’ again.</Footer>
        </Text>
		</StyledModal>
    </div>
    :
    <div>
       <StyledTransactionsTop>
        <CreateButton type="primary" onClick={() => setRenewModalVisible(true)} >
         <CreditCardOutlined /> RENEW SUBSCRIPTION
       </CreateButton>
      </StyledTransactionsTop>
    </div>
  )
}

export default TransactionsListTop
